<template>
    <v-card class="overflow-hidden">
        <v-app-bar id="menu" app dense flat tile elevation="0" color="#fff" class="menu-border" height="48px">
            <v-toolbar-title class="hidden-sm-and-down" :class="[$vuetify.breakpoint.width > 1263 ? 'pr-4' : '']" style="width: 170px; max-width: 170px">
                <router-link v-if="user && user.type === $const.USER_TYPE_PLAYER_ID" :to="{ name: 'favourite' }" style="text-decoration: none; color: inherit">
                    <img class="main-logo" width="200" alt="logo" src="/images/main/TB_Logo_Green.svg" />
                </router-link>
                <img v-else class="main-logo" width="200" alt="logo" src="/images/main/TB_Logo_Green.svg" />
            </v-toolbar-title>

            <AppMenuNav v-if="isDesktopMenu" :items="navMenuItems"></AppMenuNav>

            <v-app-bar-nav-icon v-if="!isDesktopMenu" class="ml-n3 ml-md-0" @click="mobileMenuDrawer = true">
                <v-icon color="tbGreen" style="background: transparent !important">mdi-menu</v-icon>
            </v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <AppSearch></AppSearch>
            <!--            <AppMenuBreadcrumbs></AppMenuBreadcrumbs>-->

            <!--            <v-divider-->
            <!--                class="menu-divider"-->
            <!--                :class="[$vuetify.breakpoint.width < 524 ? 'd-none d-sm-flex' : '']"-->
            <!--                inset-->
            <!--                vertical-->
            <!--            ></v-divider>-->

            <AppMenuUserBalanceInfo v-if="$vuetify.breakpoint.width > 680"></AppMenuUserBalanceInfo>

            <AppMenuDarkSwitcher></AppMenuDarkSwitcher>

            <AppMenuAccountTB></AppMenuAccountTB>

            <AppMenuNotification></AppMenuNotification>

            <AppMenuHelp :items="navMenuSupportItems"></AppMenuHelp>
        </v-app-bar>
        <!--        <AppMenuMobile :items="navMenuItems"></AppMenuMobile>-->
        <!--    </v-container>-->
    </v-card>
</template>
<style scoped>
    .theme--dark {
        background-color: #1e1f22 !important;
        color: white !important;
    }
</style>
<script>
    import utils from '../../helpers/utils';
    import AppMenuNotification from './AppMenuNotification';
    import AppMenuHelp from './AppMenuHelp';
    import AppMenuDarkSwitcher from './AppMenuDarkSwitcher';
    import AppMenuMobile from './AppMenuMobile';
    import AppMenuUserBalanceInfo from 'Components/menu/AppMenuUserBalanceInfo';
    import AppMenuBreadcrumbs from './AppMenuBreadcrumbs';
    import AppSearch from './../../pages/core/search/AppSearch';
    import AppMenuNav from './AppMenuNav';
    import AppMenuAccountTB from './AppMenuAccountTB';

    export default {
        name: 'app-menu-tb-player',
        components: {
            AppMenuAccountTB,
            AppMenuNav,
            AppMenuBreadcrumbs,
            AppMenuUserBalanceInfo,
            AppMenuMobile,
            AppMenuNotification,
            AppMenuHelp,
            AppMenuDarkSwitcher,
            AppSearch,
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },
        mounted() {
            this.requiredDictionaries = ['TimeZone', 'Site'];
        },

        mixins: [utils],
        methods: {},
        computed: {
            mobileMenuDrawer: {
                get() {
                    return this.$store.getters['MenuModule/getMobileMenuDrawer'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setMobileMenuDrawer', value);
                },
            },
            requiredDictionaries: {
                get() {
                    return this.$store.getters['PageModule/getRequiredDictionaries'];
                },
                set(value) {
                    this.$store.commit('PageModule/setRequiredDictionaries', value);
                },
            },
            navMenuSupportItems: {
                get() {
                    return this.$store.getters['MenuModule/getNavMenuSupportItems'];
                },
            },
            navMenuItems: {
                get() {
                    return this.$store.getters['MenuModule/getNavMenuItems'];
                },
            },
            toolUserSettings: {
                get() {
                    return this.$store.getters['AppModule/getToolUserSettings'];
                },
                set(value) {
                    this.$store.commit('AppModule/setToolUserSettings', value);
                },
            },
            user() {
                return this.$store.getters['UserModule/getUser'];
            },
            isDesktopMenu() {
                let width = 1425;
                if (!this.toolUserSettings.is_show_exposure) {
                    width = width - 130;
                }
                if (!this.toolUserSettings.is_show_balance) {
                    width = width - 130;
                }
                if (!this.toolUserSettings.is_show_credit) {
                    width = width - 115;
                }

                const isDesktopMenu = this.$vuetify.breakpoint.width > width;

                if (isDesktopMenu === true && this.mobileMenuDrawer === true) {
                    this.mobileMenuDrawer = false;
                }
                return isDesktopMenu;
            },
        },
    };
</script>
